var Marionette = require('marionette')
var MapRadiusModule = require('src/common/mapRadius')
var _ = require('lodash')

var FilterLocation = Marionette.View.extend({
  template: require('../templates/filter-location.html'),
  className: 'filter-text',
  events: {
    'change .js-radius-select': 'onValueChange'
  },
  modelEvents: {
    'change': 'modelChange'
  },
  modelChange: function () {
    var value = this.model.get('value')
    var location = value.location
    var radius = value.radius
    this.editMap.setRadiusIndicator(location, radius)
    this.editMap.setLocationMarker(location)
  },
  initialize: function () {
  },
  onValueChange: function (ev) {
    var value = Object.assign(this.model.get('value'), {'radius': ev.currentTarget.value})
    this.model.set('value', value)
    this.model.trigger('change')
  },

  updateMap: function (location, radius) {
    this.editMap.setRadiusIndicator
  },
  onDomRefresh: function () {
    var self = this
    var location = _.get(self.model, 'attributes.value.location')

    var LocationMap = MapRadiusModule.extend({
      
    })
  //   // map
    self.editMap = new LocationMap({
      'container': 'filter-location-map',
      'location': location,
      'zoomLevel': 13
    })
    //
    self.editMap.setRadiusIndicator(location, 1000)
    // self.editMap.setRadiusIndicator(location, 51000)

  //  marker = L.circle(location, 1000).addTo(map)

    var updateLocation = function (location) {
      var value = Object.assign(self.model.get('value'), {'location': location})
    //  self.updateMap()
      self.model.set('value', value)
      self.model.trigger('change')
    }
    var onDragEnd = function (event) {
      var marker = event.target // you could also simply access the marker through the closure
      var coordinates = marker.getLatLng() // but using the passed event is cleaner
      updateLocation([coordinates.lat, coordinates.lng])
    }
  //
    self.editMap.createLocationMarker([0, 0], onDragEnd)
    self.editMap.setLocationMarker(location)
    self.editMap.registerMapClick(function (coordinates) {
      updateLocation([coordinates.lat, coordinates.lng])
    })
  },

  templateContext: function () {
    var self = this
    return {
      'getValue': function () {
        var value = self.model.get('value') || self.model.get('selectedValues')
        if (value === false) value = ''
        return ''
      }
    }
  }
})

module.exports = FilterLocation



// WEBPACK FOOTER //
// ./js/components/devices-filter/views/filter-location.js